import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { InfoEntregaComp } from "./infoentrega";
import { GuiaList } from "app/features/general/operativa/items/resumenchoferze/list/componentes/guias/list";

type Entity = models.LiberacionEntregaZEDTO;
export interface Props {
    value: Entity;
}

/**
* Valida un LiberacionEntregaZE
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

const ImprimirButton = kea.defaultProps(kea.Button, { children: "Imprimir acuses internos", iconClass: fa("print") });
/**
* Componente para editar un Entity
*/
export class LiberacionEntregaZEFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    onImprimirAcuses = async () => {
        const data = await resources.LiberacionEntregaZE.ImprimirAcusesInternos(this.props.value.IdRegistro);
        await kea.printPdf(data);
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const DateTime = getField(kea.DateTime);
        const guias = this.props.value.Guias ;
        
        return (
            <div>
                <kea.Title titulo="Liberacion entrega de zona extendida" onRegresar={() => history.go("../")} >
                    <ImprimirButton onClick={this.onImprimirAcuses} />
                </kea.Title>
                {kea.autogrid(3, [
                    <Text field="NombreUsuario" label="Usuario:" readonly />,
                    <DateTime field="FechaLiberacion" label="Fecha:" readonly />,
                    <Text field="NombreChoferZE" label="Chofer de zona extendida:" readonly />,
                    <Number field="TotalFXC" label="Total de Flete por cobrar:" format="currency" readonly />,
                    <Number field="CantGuias" label="Cantidad de guías:" readonly />,
                    <Number field="CantidadAcuses" label="Cantidad de acuses:" readonly />
                ])}
                <GuiaList value={guias} />
            </div>);
            /*
            <div className="row">
                    {
                        value.EntregasLiberadas.map(x =>
                            <div className="col-md-6">
                                <InfoEntregaComp value={x} />
                            </div>
                        )
                    }
                </div>
            */
    }
}

export const LiberacionEntregaZEForm = componentToRx(LiberacionEntregaZEFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/edit/form.tsx